// src/shared/api-client/endpoints/repFinder.js
// Rep Finder API endpoints

import { baseApi } from "../baseApi";

/**
 * Rep Finder API endpoints
 * Provides flowchart read + admin CRUD for the "Find Your Rep" feature
 */
const repFinderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get the flowchart (all members; admins also see drafts)
    getRepFinderFlowchart: builder.query({
      query: () => "/api/rep-finder",
      providesTags: ["RepFinder"],
    }),

    // Full upsert — replaces all steps and items (MANAGE_REP_FINDER)
    upsertRepFinderFlowchart: builder.mutation({
      query: (data) => ({
        url: "/api/rep-finder",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["RepFinder"],
    }),

    // Publish the flowchart (MANAGE_REP_FINDER)
    publishRepFinderFlowchart: builder.mutation({
      query: () => ({
        url: "/api/rep-finder/publish",
        method: "PATCH",
      }),
      invalidatesTags: ["RepFinder"],
    }),

    // Unpublish the flowchart (MANAGE_REP_FINDER)
    unpublishRepFinderFlowchart: builder.mutation({
      query: () => ({
        url: "/api/rep-finder/unpublish",
        method: "PATCH",
      }),
      invalidatesTags: ["RepFinder"],
    }),

    // Delete the entire flowchart (MANAGE_REP_FINDER)
    deleteRepFinderFlowchart: builder.mutation({
      query: () => ({
        url: "/api/rep-finder",
        method: "DELETE",
      }),
      invalidatesTags: ["RepFinder"],
    }),
  }),
});

export const useGetRepFinderFlowchartQuery =
  repFinderApi.useGetRepFinderFlowchartQuery;
export const useUpsertRepFinderFlowchartMutation =
  repFinderApi.useUpsertRepFinderFlowchartMutation;
export const usePublishRepFinderFlowchartMutation =
  repFinderApi.usePublishRepFinderFlowchartMutation;
export const useUnpublishRepFinderFlowchartMutation =
  repFinderApi.useUnpublishRepFinderFlowchartMutation;
export const useDeleteRepFinderFlowchartMutation =
  repFinderApi.useDeleteRepFinderFlowchartMutation;
